import React from 'react'

import clsx from 'clsx'

import { Paper, makeStyles, Typography } from '@material-ui/core'

import styles from './styles'

const useStyles = makeStyles(styles)

const CartList = ({ children: childrenProps, ...rest }) => {
  const classes = useStyles()
  const children = React.Children.toArray(childrenProps)

  return (
    <Paper className={clsx(classes.root, rest.className)}>
      {children.length ? (
        children
      ) : (
        <Typography color="textSecondary" align="center">
          Nenhum plano adicionado ao carrinho.
        </Typography>
      )}
    </Paper>
  )
}

export default CartList
